interface TimeIconProps {
  color?: string;
  size?: number;
}

export default function TimeIcon({
  color = "#6B7280",
  size = 18,
}: TimeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346628 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9978 5.87895 15.1542 3.84542 13.6544 2.34562C12.1546 0.845814 10.121 0.00223986 8 0ZM12.3077 8.61538H8C7.83679 8.61538 7.68027 8.55055 7.56486 8.43514C7.44945 8.31973 7.38462 8.16321 7.38462 8V3.69231C7.38462 3.5291 7.44945 3.37257 7.56486 3.25716C7.68027 3.14176 7.83679 3.07692 8 3.07692C8.16321 3.07692 8.31974 3.14176 8.43514 3.25716C8.55055 3.37257 8.61539 3.5291 8.61539 3.69231V7.38461H12.3077C12.4709 7.38461 12.6274 7.44945 12.7428 7.56486C12.8582 7.68026 12.9231 7.83679 12.9231 8C12.9231 8.16321 12.8582 8.31973 12.7428 8.43514C12.6274 8.55055 12.4709 8.61538 12.3077 8.61538Z"
        fill={color}
      />
    </svg>
  );
}
